import { makeStyles } from "@material-ui/core/styles";
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import Person from "@material-ui/icons/Person";
import Timeline from "@material-ui/icons/Timeline";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import Card from "components/Card/Card.js";
import CardFooter from "components/Card/CardFooter.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import ClassDashboard from 'components/ClassDashboard';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import moment from 'moment';
import React from "react";
import {NavLink, Link} from "util/router";
import { useSelector } from 'react-redux';
import { Route, Switch } from "util/router.js";
import ClassesTable from 'components/ClassesTable';
import NewClassButton from 'components/Store/NewClassButton'
import ClassEditor from "./Store/ClassEditor";
import ReferralPage, {Referrals} from 'pages/referrals'
import ServicesPage from 'components/Store/Services'

const useStyles = makeStyles(styles);

function HomePageStats(props) {

  const instructor = useSelector(state => state.instructor.instructor);
  const currency = useSelector(state => state.instructor.instructor?.instructorProfile?.currency ?? "USD")
  const currencyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
  });

  const dashboard = useSelector(state => state.instructor.dashboard);

  const NOW = moment().unix()
  var sorted_todays_classes =  useSelector(state => state.instructor.classes.filter(val => {
    return NOW < (val.start_time + val.duration * 60) && moment(val.start_time * 1000).isSame(moment(), 'day')
  }).sort(function (a, b) {
    if (a.start_time && b.start_time) {
      return a.start_time - b.start_time;
    }
    return 0;
  }))

  let viewModel = {
    totalBookings: dashboard.reservationsCount ?? "loading",
    lastThirtyRevenue: dashboard.lastThirtyRevenue ? currencyFormatter.format((dashboard.lastThirtyRevenue ?? 0) / 100): "loading",
    lastThirtyViews: dashboard.lastThirtyViews ?? 0,
    ratingOverall: dashboard.ratingOverall ?? "loading",
    numberOfRatings: dashboard.numberOfRatings ?? 0,
    lastUpdatedTimestamp: dashboard.lastUpdatedTimestamp ?? 0,
    totalStudents: dashboard.uniqueClients,
    followerCount: dashboard.followerCount ?? 0,
    pageViews: "Coming Soon",
    profileImageUrl: instructor.profileImageUrl ?? ""
  }

  const classes = useStyles();
  const todaysClass = sorted_todays_classes?.length > 0 ? sorted_todays_classes[0] : null;
  
  return (
    <>

    {todaysClass && (todaysClass.content_link || todaysClass.reserve_link) && (() => {
        return (
            <div className="alert alert-primary d-flex d-row align-items-center" role="alert">
                <div>{`Good ${getGreetingTime(moment())}! You have a class today at ${moment(todaysClass.start_time * 1000).format("h:mm a")}. `}</div>
                <a type="button" className="ml-3 btn btn-primary" 
                  href={todaysClass.content_link || todaysClass.reserve_link}
                  target="_blank"
                  >
                  Access Here
                </a>
            </div>
        )
    })()}
    <div className='d-flex d-column align-items-center'>
      <h2 className="font-weight-bold">Overview</h2>
      <NavLink to='/dashboard/revenue'>View More</NavLink>
    </div>
    <GridContainer>
      <GridItem xs={12} sm={6} md={6} lg={3}>
        <Card>
          <CardHeader color="navy" stats icon>
            <CardIcon color="navy">
              <Timeline />
            </CardIcon>
            <p className={classes.cardCategory}>Total bookings</p>
            <h3 className={classes.cardTitle}>
              {viewModel.totalBookings} 
              {/* <small>${viewModel.lastThirtyRevenue}</small> */}
            </h3>
          </CardHeader>
          <CardFooter stats>
            <div className={classes.stats}>
              {/* <DateRange /> */}
              Total number of bookings on Sutra
            </div>
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={6} lg={3}>
        <Card>
          <CardHeader color="info" stats icon>
            <CardIcon color="info">
              <AttachMoneyIcon/>
            </CardIcon>
            <p className={classes.cardCategory}>Revenue</p>
            <h3 className={classes.cardTitle}>
              {viewModel.lastThirtyRevenue}
            </h3>
          </CardHeader>
          <CardFooter stats>
            <div className={classes.stats}>
              {/* <DateRange /> */}
              Revenue in last 30 days
            </div>
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={6} lg={3}>
        <Card>
          <CardHeader color="primary" stats icon>
            <CardIcon color="primary">
              <Person/>
            </CardIcon>
            <p className={classes.cardCategory}>Total students</p>
            <h3 className={classes.cardTitle}>
              {viewModel.totalStudents}
            </h3>
          </CardHeader>
          <CardFooter stats>
            <div className={classes.stats}>
              {/* <DateRange /> */}
              Total students who have taken your class
            </div>
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={6} lg={3}>
        <Card>
          <CardHeader color="primary" stats icon>
            <CardIcon color="primary">
              <Person/>
            </CardIcon>
            <p className={classes.cardCategory}>Followers</p>
            <h3 className={classes.cardTitle}>
              {viewModel.followerCount}
            </h3>
          </CardHeader>
          <CardFooter stats>
            <div className={classes.stats}>
              {/* <DateRange /> */}
              People who follow you on the Sutra app
            </div>
          </CardFooter>
        </Card>
      </GridItem>
    </GridContainer>
    </>
  )
}


function HomeDashboard(props) {

  const {match } = props;
  // console.log("Match: " + match)

  moment.locale('en', {
    calendar : {
        lastDay : '[Yesterday]',
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        lastWeek : '[last] dddd [at] LT',
        nextWeek : 'dddd [at] LT',
        sameElse : 'dddd MMM Do'
    }
});

  const [showPrevious, setShowPrevious] = React.useState(false)
  
  

  function HomeSection() {
    return (
    
    <div className="container px-0">
      <section className="mb-5">
        <Referrals {...props} showExtra={false} />
      </section>
      
      <section className="mb-5">
        <HomePageStats {...props}/>
      </section>
      <section>
        <div className='d-flex d-row justify-content-between align-items-center mb-4'>
          <div className="d-flex d-row align-items-center">
            <h2 className="font-weight-bold">Schedule</h2>
            <button 
            type="button" 
            className="btn btn-link"
            onClick={() => setShowPrevious(!showPrevious)}
            >
              {showPrevious ? "Show Upcoming" : "Show Previous"}
            </button>
          </div>
          
          <div className="float-right d-flex flex-column align-items-center">
            <NewClassButton className="float-right mb-2" {...props}/>  
            <Link to="/dashboard/home/templates">Templates</Link>
          </div>
          
          {/* <NavLink href='/dashboard/schedule'>View More</NavLink> */}
        </div>
        <ClassesTable
          {...props}
          showPrevious={showPrevious}
          // history={history}
          // baseUrl={match.url}
          // classes={instructor_classes}
          />
      </section>
    </div>
    );
  }

  return (
    <Switch>
      <Route 
            path={`${match.url}/referral`} 
            render={props => {
              return <ReferralPage {...props}/>
            }} 
      />
      <Route 
            path={`${match.url}/class/:platformID`} 
            render={props => {
              return <ClassDashboard {...props}/>
            }} 
        />
        <Route 
            path={`${match.url}/create`} 
            render={props => {
              return (<div className="container"><ClassEditor newClass sendingUrl={match.url} {...props}/></div>)
            }} 
        />
        <Route 
            path={`${match.url}/templates`} 
            render={props => {
              return (<div className="container"><ServicesPage {...props}/></div>)
            }} 
        />
        <Route path="/">
          <HomeSection />
        </Route>
    </Switch>
  );
}

export default HomeDashboard;


/* USE
    //The var "humanizedGreeting" below will equal (assuming the time is 8pm) "Good evening, James."
    
    var user = "James";
    var humanizedGreeting = "Good " + getGreetingTime(moment()) + ", " + user + ".";
*/
function getGreetingTime (m) {
	var g = null; //return g
	
	if(!m || !m.isValid()) { return; } //if we can't find a valid or filled moment, we return.
	
	var split_afternoon = 12 //24hr time to split the afternoon
	var split_evening = 17 //24hr time to split the evening
	var currentHour = parseFloat(m.format("HH"));
	
	if(currentHour >= split_afternoon && currentHour <= split_evening) {
		g = "afternoon";
	} else if(currentHour >= split_evening) {
		g = "evening";
	} else {
		g = "morning";
	}
	
	return g;
}